import PaymentStatusLabel from './PaymentStatusLabel';

export default PaymentStatusLabel;
